module.exports = __webpack_public_path__ + "img/1.ff00212d.jpg";